export const LIMIT_AFFILIATES_LIST = 10;
